module.exports = __webpack_public_path__ + "static/media/DSC04148-2.2116b0c7.jpg";